<template>
  <div class="home h-100">
    <!-- Navigation -->
    <Navbar />
    <section class="hero-header h-100">
      <div class="container">
            <div class="description text-center" data-aos="fade-down">
                <h1 class="">Get in touch with us</h1>
                <p class="">Our team is very quick to respond to 
your inquiry</p>
            </div>
        </div>
    </section>

    <!-- contact-wrapper -->
    <section class="contact-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
              <div class="contact-us" data-aos="fade-up">
                    <h3 class="pl-4 pt-4">Contact Us</h3>
                    <ul class="address">
                        <li>
                            <div class="d-flex">
                                <div class="mr-2">
                                    <img src="/img/icons/black/Home.svg" alt="">
                                </div>
                                <div class="contact-description">UAC Building, 1-5 Odunlami St, Lagos Island, Lagos</div>
                            </div>
                        </li>
                        <li>
                            <div class="d-flex">
                                <div class="mr-2">
                                    <img src="/img/icons/black/mail.svg" alt="">
                                </div>
                                <div class="contact-description">+2348169352843</div>
                            </div> 
                        </li>
                        <li>
                            <div class="d-flex">
                                <div class="mr-2">
                                    <img src="/img/icons/black/telephone.svg" alt="">
                                </div>
                                <div class="contact-description">info@coralstone.capital</div>
                            </div>
                        </li>
                    </ul>
                    <div class="mpp">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.554875292095!2d3.3876879141387497!3d6.451144725791555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8b1022ca077f%3A0x6fca776f4925814c!2sUAC%20Building%20Lagos%20Island!5e0!3m2!1sen!2sng!4v1588944134034!5m2!1sen!2sng" width="600" height="450" frameborder="0" style="border:0; width: 100%;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> 
                    </div>
              </div>
          </div>
          <div class="col-md-6">
            <div class="form-wrapper" data-aos="fade-up">
              <h3 class="">Send us a message</h3>
               <ValidationObserver ref="form">
                <form class="form" @submit.prevent="validateBeforeSubmit">
                      <div class="alert-wrap mt-4">
                          <div v-if="errorMessages"  class="alert-danger p-3 error-message">
                              <div v-for="(errorMessage,index) in errorMessages" :key="index">{{ errorMessage[0] }}</div>
                          </div>
                          <div v-else-if="networkErrorMessage" class="alert-danger p-3 error-message">{{ networkErrorMessage }}</div>
                      </div>
                      <div class="form-group">
                          <label for="firstName">First Name</label>
                          <ValidationProvider name="first name" rules="required" v-slot="{ errors }">
                            <input type="text" v-model="firstName" class="form-control" id="firstName" placeholder="First Name">
                            <span class="validation-error mt-2">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group">
                          <label for="lastName">Last Name</label>
                          <ValidationProvider name="last name" rules="required" v-slot="{ errors }">
                          <input type="text" v-model="lastName" class="form-control" id="lastName" placeholder="Last Name">
                          <span class="validation-error mt-2">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group">
                          <label for="email">Email</label>
                          <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                            <input type="email" v-model="email" class="form-control" id="email" placeholder="you@email.com">
                            <span class="validation-error mt-2">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group">
                          <label for="subject">Subject</label>
                          <ValidationProvider name="subject" rules="required" v-slot="{ errors }">
                            <input type="text" v-model="subject" class="form-control" id="subject" placeholder="Subject">
                            <span class="validation-error mt-2">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                       <div class="form-group">
                          <label for="subject">Coralstone Unit</label>
                          <ValidationProvider name="sub" rules="required" v-slot="{ errors }">
                            <select class="form-control" v-model="coralstoneUnit">
                              <option selected disabled value="">Choose...</option>
                               <option>Vale Finance</option>
                               <option>VantLead</option>
                               <option>Vale Asset Management</option>
                               <option>Ambission</option>
                            </select>
                            <span class="validation-error mt-2">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group">
                          <label for="message">Message</label>
                          <ValidationProvider name="message" rules="required" v-slot="{ errors }">
                          <textarea class="form-control" v-model="message" rows="4" id="message"></textarea>
                          <span class="validation-error mt-2">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group">
                          <input type="submit" class="btn btn-primary btn-block" value="Send Message">
                      </div>
                  </form>
               </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer"
import Navbar from "../components/Navbar.vue";

export default {
  name: 'Home',
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      subject: '',
      message: '',
      coralstoneUnit: '',
      errorMessages: '',
      networkErrorMessage: ''
    }
  },
  methods: {

     validateBeforeSubmit() {
        this.$refs.form.validate().then(success => {
            if(success) {
                this.submitForm();
            }
        });
    },

    submitForm() {
      let formData = {}

      formData = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        subject: this.subject,
        message: this.message,
        coralstoneUnit: this.coralstoneUnit
      }

      console.log(formData);

      this.axios.post('http://localhost/contactUsSubmit.php', formData, {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        })
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error)
        })

      // this.firstName = '';
      // this.lastName = '';
      // this.email = '';
      // this.subject = '';
      // this.message = '';
      // this.sub = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables/colors.scss";
  

  // hero header styles
  .hero-header {
      background-image: url("../../public/img/contact-hero-header.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      padding-top: 10rem;

      .description {
          color: #fff;

          h1 {
              font-family: 'Poppins', sans-serif;
              font-weight: bold;
              font-size: 64px;
              line-height: 96px;
              letter-spacing: 0.02em;
          }

          p {
              font-family: 'Poppins', sans-serif;
              font-size: 22px;
              line-height: 32px;
              padding: 0 15rem;
              text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          }
      }
  }

  // contact
  h3 {
    font-family: 'Montserrat', sans-serif;
    font-weight: bold;
    font-size: 32px;
    line-height: 39px;
    letter-spacing: 0.02em;
    color: #171F4A;
  }
  .contact-wrapper {
    padding: 2rem 0 6rem 0;

    .contact-us {
        background: #FFFFFF;
        border-radius: 16px;

        .address {
            list-style-type: none;
            padding: 0 0 1.5rem 1.5rem;
            margin: 0 0 5rem;
            width: 50%;

            .contact-description {
                margin-bottom: 1.5rem;
            }
        }

    }

    .contact-us, .form-wrapper {
        margin-bottom: 2rem;

        .address, .form {
            margin-top: 2rem;
        }
    }

    .form-wrapper {
        background: #FFFFFF;
        border-radius: 16px;
        padding: 1.5rem 1.5rem 5.5rem;

        .form {
          .form-control {
            background: #F1F3F4;
            border-radius: 4px;
            border-color: #F1F3F4;

            &:focus {
              box-shadow: none;
            }
          }

          .validation-error {
            color: #e02626;
          }
        }
    }

    
  }
 

  @media (min-width: 992px) and (max-width: 1199px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 54px;
                line-height: 72px;
            }

            p {
                font-size: 22px;
                line-height: 32px;
                padding: 0 10rem;
            }
        }
    }

    h3 {
      font-size: 28px;
    }

    .contact-wrapper {
      .contact-us {

        .address {
            width: 65%;
        }

      }
    }
  }

  @media (min-width: 767px) and (max-width: 991px) {
    .hero-header {
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 44px;
                line-height: 72px;
            }

            p {
                font-size: 18px;
                line-height: 32px;
                padding: 0 5rem;
            }
        }
    }

    h3 {
      font-size: 24px;
    }

    .contact-wrapper {
      //margin-top: -3rem;
      padding: 0 0 6rem 0;

      .contact-us {

        .address {
            width: 83%;
        }

      }
    }
  }

  @media (max-width: 767px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        padding-top: 8rem;

        .description {

            h1 {
                font-size: 38px;
                line-height: 57px;
                padding: 0 2rem;
            }

            p {
                font-size: 18px;
                line-height: 32px;
                padding: 0 5rem;
            }
        }
    }

    h3 {
      font-size: 24px;
      text-align: left;
    }

    .contact-wrapper {
      margin-top: -3rem;
  
      .contact-us {

        .address {
            width: 83%;
        }

      }

      .form-wrapper {
        padding-bottom: 3.5rem;
        margin-bottom: 0;
      }
    }

  }

  @media (max-width: 575px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");
        //padding-top: 6rem;

        .description {

            h1 {
                line-height: 46px;
                padding: 0 1rem;
            }

            p {
                padding: 0 3rem;
            }

        }
    }

    .contact-wrapper {
      .contact-us {
        .address {
            width: 80%;
        }
      }
    }

    
  }

  @media (max-width: 375px) {
    .hero-header {
        //background-image: url("../../public/img/mobile/hero-header-mobile.svg");

        .description {

            h1 {
                font-size: 35px;
            }

            p {
                font-size: 17px;
                padding: 0 2rem;
            }
        }
    }

    h3 {
      font-size: 21px;
    }

    .contact-wrapper {
      .contact-us {
        .address {
            width: 94%;
        }
      }
    }

    
  }


</style>

